const manifestoItems = {
  heading:
    "Acreditamos no <span style='color:#0fd24f'>poder das relações</span> para criar o extraordinário",
  paragraph:
    "Existe um imenso potencial de negócios e de inclusão social nos Objetivos Globais das Nações Unidas. A marca que deixamos, como cidadãos e líderes empresariais, está justamente na transformação de metas globais em metas de negócio, incorporando o fator socioambiental em qualquer equação.",
};

export default manifestoItems;
